(function () {
  function initParallax() {
    var images = document.querySelectorAll('.brand-statement__media img');
    if (!images.length) return;

    var ticking = false;

    function update() {
      images.forEach(function (img) {
        var rect = img.parentElement.getBoundingClientRect();
        var center = rect.top + rect.height / 2 - window.innerHeight / 2;
        var offset = center * 0.12;
        img.style.transform = 'translateY(' + offset + 'px) scale(1.18)';
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();
